<script>
import $ from 'domtastic';
import vueMixins from 'viralstyle-ui/src/vueMixins';

export default {
  mixins: [vueMixins],
  props: {
    image: String,
    text: String,
    fill: String,
    route: Object,
  },
  data: () => ({
    shouldLoad: false,
  }),
  created() {
    $(window).on('scroll', this.$_handleScroll);
    $(window).on('touchmove', this.$_handleScroll);
  },
  mounted() {
    setTimeout(() => this.$_handleScroll(), 1);
  },
  beforeDestory() {
    this.$_detachScrollEvents();
  },
  methods: {
    $_detachScrollEvents() {
      $(window).off('scroll', this.$_handleScroll);
      $(window).off('touchmove', this.$_handleScroll);
    },
    $_handleScroll() {
      if (this.elementEnteredViewPort(this.$el)) {
        this.shouldLoad = true;

        this.$_detachScrollEvents();
      }
    },
  },
};
</script>

<template lang='pug'>
router-link.max-w-category-image.mx-_75.text-center.min-w-0.w-full.mt-3.md_mt-0.cursor-pointer.text-black.hover_text-brand.transition-250.transition-color(
  tabindex='0',
  tag='div',
  :to='route',
)
  svg.h-full.w-full(xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', viewBox='0 0 148 148')
    path(:fill='fill', d='M74 148c40.87 0 74-33.13 74-74S114.87 0 74 0 0 33.13 0 74s33.13 74 74 74z')
    g(opacity='.47')
      path.text-white.fill-current(d='M74 126c28.719 0 52-23.281 52-52s-23.281-52-52-52-52 23.281-52 52 23.281 52 52 52z')
    image.opacity-100(v-if='shouldLoad', width='100%', height='100%', :xlink:href='image')

  .text-2xl.md_text-xl.mt-1 {{text}}
</template>

<style>
@import '~import/index';
</style>